module.exports = __webpack_public_path__ + "static/media/left.7a13ac35.svg";